<script>
    import { onMount } from "svelte";
    export let id;
    let libera = false;
    $: if (id == "3125") {
        libera = true;
    }
    let message = "";

    let grupos = {};
    let mataMata = {}; // Armazena as partidas de quartas, semi e final

    async function fetchGrupos() {
        const response = await fetch(
            "https://www.linkagenda.com.br/torneio_domino/grupos.php",
        );
        const data = await response.json();
        grupos = data;
    }

    async function fetchMataMata() {
        const response = await fetch(
            "https://www.linkagenda.com.br/torneio_domino/mata_mata.php",
        );
        const data = await response.json();
        mataMata = data;
    }

    function generateId(dupla1, dupla2) {
        return `${dupla1.replace(/\s+/g, "_")}_vs_${dupla2.replace(/\s+/g, "_")}`;
    }

    async function updateScore(
        grupo,
        dupla1,
        dupla2,
        resultadoDupla1,
        resultadoDupla2,
        mata_mata = false,
    ) {
        const data = {
            grupo,
            dupla1,
            dupla2,
            resultado_dupla1: resultadoDupla1,
            resultado_dupla2: resultadoDupla2,
            mata_mata: mata_mata,
        };
        console.log(JSON.stringify(data));
        message = "Atualizando....";
        const response = await fetch(
            "https://www.linkagenda.com.br/torneio_domino/atualiza.php",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            },
        );

        const result = await response.json();
        if (result.status == "sucesso") {
            message = "Atualizado!";
        }
        console.log("Resultado da API:", result);
    }

    function handleInputChange(grupo, partida, e, mata_mata = false) {
        const inputId = e.target.id;
        if (inputId.includes("_dupla1")) {
            partida.dupla1 = e.target.value;
        } else if (inputId.includes("_dupla2")) {
            partida.dupla2 = e.target.value;
        } else if (inputId.includes("_res1")) {
            partida.resultado_dupla1 = e.target.value;
        } else if (inputId.includes("_res2")) {
            partida.resultado_dupla2 = e.target.value;
        }

        updateScore(
            grupo,
            partida.dupla1,
            partida.dupla2,
            partida.resultado_dupla1,
            partida.resultado_dupla2,
            mata_mata,
        );
    }
    function reloadPage() {
        location.reload();
    }
    onMount(() => {
        // Carrega os dados inicialmente
        fetchGrupos();
        fetchMataMata();
        if (!libera) {
            // Define o intervalo para recarregar a página a cada 13 segundos
            const interval = setInterval(reloadPage, 17000);

            // Limpa o intervalo quando o componente for destruído
            return () => {
                clearInterval(interval);
            };
        }
    });
</script>

{message}
<div class="back">
    <!-- Exibição das fases de grupos -->
    <div class="container mt-4">
        {#each Object.keys(grupos) as grupo}
            <h3 class="text-center mb-3">Grupo {grupo}</h3>
            <div class="table-responsive">
                <table class="table table-bordered table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>Dupla 1</th>
                            <th>P</th>
                            <th>vs</th>
                            <th>P</th>
                            <th>Dupla 2</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each grupos[grupo] as partida}
                            {#if partida.resultado_dupla2 < 6 && partida.resultado_dupla1 < 6 && (partida.resultado_dupla1 > 0 || partida.resultado_dupla2 > 0)}
                                <td colspan="5">
                                    A partida a seguir está em andamento</td
                                >
                            {:else if (partida.resultado_dupla2 >= 6 || partida.resultado_dupla1 >= 6) && partida.resultado_dupla2 != partida.resultado_dupla1}
                                <td colspan="5"
                                    >A partida a seguir foi finalizada</td
                                >
                            {/if}
                            <tr>
                                <td
                                    >{@html partida.dupla1.replace(
                                        "/",
                                        "<br>&<br>",
                                    )}</td
                                >
                                <td>
                                    <input
                                        type="text"
                                        id="{generateId(
                                            partida.dupla1,
                                            partida.dupla2,
                                        )}_res1"
                                        class="form-control"
                                        bind:value={partida.resultado_dupla1}
                                        on:input={(e) =>
                                            handleInputChange(
                                                grupo,
                                                partida,
                                                e,
                                            )}
                                        disabled={!libera}
                                    />
                                </td>
                                <td>vs</td>
                                <td>
                                    <input
                                        type="text"
                                        id="{generateId(
                                            partida.dupla1,
                                            partida.dupla2,
                                        )}_res2"
                                        class="form-control"
                                        bind:value={partida.resultado_dupla2}
                                        on:input={(e) =>
                                            handleInputChange(
                                                grupo,
                                                partida,
                                                e,
                                            )}
                                        disabled={!libera}
                                    />
                                </td>
                                <td
                                    >{@html partida.dupla2.replace(
                                        "/",
                                        "<br>&<br>",
                                    )}</td
                                >
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/each}
    </div>

    <!-- Exibição das fases mata-mata (Quartas, Semi e Final) -->
    <div class="container mt-4">
        <h3 class="text-center mb-3">Fase Mata-Mata</h3>

        {#each Object.keys(mataMata) as fase}
            <h4 class="text-center mb-3">{fase}</h4>
            <div class="table-responsive">
                <table class="table table-bordered table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>Dupla 1</th>
                            <th>P</th>
                            <th>vs</th>
                            <th>P</th>
                            <th>Dupla 2</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each mataMata[fase] as partida}
                            <tr>
                                <td
                                    >{@html partida.dupla1.replace(
                                        "/",
                                        "<br>",
                                    )}</td
                                >
                                <td>
                                    <input
                                        type="text"
                                        id="{generateId(
                                            partida.dupla1,
                                            partida.dupla2,
                                        )}_res1"
                                        class="form-control"
                                        bind:value={partida.resultado_dupla1}
                                        on:input={(e) =>
                                            handleInputChange(
                                                fase,
                                                partida,
                                                e,
                                                true,
                                            )}
                                        disabled={!libera}
                                    />
                                </td>
                                <td>vs</td>
                                <td>
                                    <input
                                        type="text"
                                        id="{generateId(
                                            partida.dupla1,
                                            partida.dupla2,
                                        )}_res2"
                                        class="form-control"
                                        bind:value={partida.resultado_dupla2}
                                        on:input={(e) =>
                                            handleInputChange(
                                                fase,
                                                partida,
                                                e,
                                                true,
                                            )}
                                        disabled={!libera}
                                    />
                                </td>
                                <td
                                    >{@html partida.dupla2.replace(
                                        "/",
                                        "<br>&<br>",
                                    )}</td
                                >
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/each}
    </div>
</div>

<style>
    .back {
        background-image: url("/img/domino2.jpg");

        background-position: center; /* Para centralizar a imagem */
    }

    table {
        width: 100%;
        margin-bottom: 20px;
        border-collapse: separate;
        border-spacing: 0 10px;
    }

    thead {
        background-color: #f8f9fa;
    }

    th {
        text-align: center;
    }

    tbody tr {
        background-color: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    }

    td {
        vertical-align: middle;
        text-align: center;
        padding: 10px;
    }

    input {
        text-align: center;
        border: 1px solid #ced4da;
        border-radius: 5px;
        padding: 5px;
        width: 100%; /* Faz com que o input ocupe toda a largura do td */
    }

    @media (max-width: 768px) {
        td {
            font-size: 14px;
            padding: 5px; /* Reduz o padding nas células */
        }

        table {
            font-size: 12px; /* Reduz o tamanho da fonte da tabela */
        }
    }

    .table-responsive {
        overflow-x: auto;
        margin-top: 20px; /* Adiciona um espaço no topo da tabela responsiva */
    }
</style>
